<template>
  <b-container fluid>
    <b-row align-v="center" class="header search">
      <b-col cols="12">
        <div class="search-back" @click="back()">{{ $t('common.return') }}</div>
        <div :class="{ 'search-input': true, 'search-input-long': !isApp }">
          <input v-model="searchKeyword" type="text" @focus="onFocus()" />
        </div>
        <div v-if="isApp" class="search-button" @click="handleMicButtonClick()">
          <img class="search-icon" src="@/assets/images/icn_mic.svg" alt />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    searchKeyword: {
      get() {
        return this.getSearchKeyword
      },
      set(value) {
        this.$store.commit('search/setSearchKeyword', value.toLowerCase())
      },
    },
    ...mapGetters({
      lastSearchedTagName: 'search/getTagName',
      getSearchKeyword: 'search/getSearchKeyword',
      showSearchResult: 'search/isShowSearchResult',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  created() {
    if (this.showSearchResult) {
      this.searchKeyword = this.lastSearchedTagName
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'shopMenu' })
    },
    onFocus() {
      this.$emit('on-focus')
    },
    handleMicButtonClick() {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/start_voice_input`
      this.$store.commit('modal/setShowingVoiceSearchModal', true)
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  .is-app & {
    background: #242424;
    box-shadow: none;
  }
  > div {
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    .is-app & {
      color: #fff;
    }
  }
}
.search {
  &-back {
    box-sizing: border-box;
    font-weight: bold;
    color: #222;
    width: 15%;
    border-radius: 5px;
    line-height: 36px;
    height: 36px;
    background-color: #e6e6e6;
    border-bottom: 2px solid #bfbfbf;
    font-size: 14px;
    // for iphone5/SE
    @media screen and (max-width: 375px) {
      font-size: 0.8rem;
    }
    &:active {
      border-top: 2px solid #242424;
      border-bottom: 0px solid #bfbfbf;
    }
  }
  &-input {
    margin-left: 10px;
    width: 70%;
    > input {
      width: 100%;
      border-radius: 5px;
      border: none;
      padding: 5px 0;
      text-indent: 10px;
    }
    &-long {
      width: 85%;
      & input {
        border: 1px solid #ccc;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2) inset;
      }
    }
  }
  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    margin-left: 8px;
    border-radius: 50%;
    background-color: #d21b24;
    border-bottom: 2px solid #96131a;
  }
  &-icon {
    width: 16px;
  }
}
</style>
